import {ILoginService} from "../services/oe/login-service";

interface ILoggedInClickScope extends ng.IScope {
	loginTpl: string;
}

export class LoggedInClick implements ng.IDirective {
	restrict = 'A';
	scope: {
		// Optional extra attribute you can pass in to request a login modal that isn't the default 'Login_Modal.ss'
        // loginTpl: '@'
	};

	constructor($uibModal : any, loginService : ILoginService) {
		this.link = (scope: ILoggedInClickScope, element: ng.IAugmentedJQuery,
					 attrs: ng.IAttributes) => {
			element.on('click', (ev) => {

				const loginTpl = attrs['loginTpl'];

				loginService.requestLogin(loginTpl).then(() => {
					scope.$eval(attrs['loggedInClick']);
				}).catch((reason) => {
					console.log('login failed', reason);
				});
				ev.preventDefault();

				/*if (userLoggedIn) {

				} else {
					let uibModalInstance = $uibModal.open({
						animation: true,
						templateUrl: '/Partial/modal/Login',
						controller: 'loginModalCtrl',
						size: 'lg',
						// scope: $scope,
						appendTo: angular.element(document.querySelector('.fullscreen') || document.querySelector('body')),
						resolve: {
							/!*items: function() {
								return $scope.items
							}*!/
						}
					});

					// If the user successfully logs in, run the click handler
					uibModalInstance.result.then((result) => {

						window['LTConfiguration']['userId'] = result.data['MemberID'];

						console.log('logged in success');
						scope.$eval(attrs['loggedInClick']);
					});

				}*/
			});
		}
	}

	link: ($scope: ng.IScope, element: ng.IAugmentedJQuery,
		   attrs: ng.IAttributes) => void = null;

	static factory(): ng.IDirectiveFactory {
		const directive = ($uibModal: any, loginService: ILoginService) => new LoggedInClick($uibModal, loginService);
		directive.$inject = ['$uibModal', 'loginService'];
		return directive;
	}
}